/**
 * Rotas de `views/Auth/` (T88, R5 e R7).
 *
 * Saíram de `src/router/rotas/Auth.ts`, recortadas linha a linha — `path`,
 * `name`, `props` e `meta` vieram inteiros. O hub passou a importar isto pelo
 * barrel e a espalhar.
 *
 * **`Auth` não é um domínio de negócio**, e o R7 diz isso com todas as letras:
 * "Os 8 `.vue` soltos na raiz de `views/` não são domínios". É uma pasta de
 * agrupamento para as três telas de entrada, e por isso ela não tem — nem deve
 * ter — `AuthApi.ts`, `Auth.type.ts`, `Auth.constantes.ts` ou
 * `papeis/auth.ts`. O que ela tem é o mínimo que a fronteira exige: as rotas e
 * a porta.
 */
import type { RouteLocationNormalizedLoaded } from "vue-router";

/** As três telas de entrada, espalhadas pelo hub `router/rotas/Auth.ts`. */
export const rotasAuth = [
  {
    path: "/acessoFederado",
    name: "AcessoFederado",
    props: true,
    component: () => import("@/views/Auth/AuthAcessoFederado.vue"),
    meta: {
      showMenu: false,
    },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Auth/AuthLogin.vue"),
    meta: {
      showMenu: false,
    },
  },
  {
    path: "/primeiroLogin",
    name: "PrimeiroLogin",
    component: () => import("@/views/Auth/AuthPrimeiroLogin.vue"),
    props: (route: RouteLocationNormalizedLoaded) => ({
      user: route.query.user,
      code: route.query.code,
    }),
    meta: {
      showMenu: false,
    },
  },
];
